import { ObjectValues } from '../../app/types/utilityTypes';

export const STORAGE_KEYS = {
  LID_NEW_COMPARE_FEATURE_TOOLTIP: 'lidNewCompareFeatureTooltip',
  LID_NEW_LINE_CHART_FEATURE_TOOLTIP: 'lidNewLineChartFeatureTooltip',
  LID_NEW_LINE_CHART_ALTER_VIEW_TOOLTIP: 'lidNewLineChartAlterViewTooltip',
} as const;

export type StorageKey = ObjectValues<typeof STORAGE_KEYS>;
